<div *ngIf="header" class="jumbotron jumbotron-fluid memic-banner" [ngStyle]="{'background-color': header.backgroundColor }">
  <div class="memic-banner__wrapper">
    <div class="memic-banner__body">
      <div class="memic-banner__body__inner">
        <h1 class="display-4" style="color: white !important;">{{ header.title }}</h1>
        <p class="lead" style="color: white !important;">{{ header.subheading }}</p>
      </div>
    </div>
    <img class="memic-banner__image" [src]="header.blobUrl">
  </div>
</div>

<div class="memic-page memic-page--boxed">
  <safetydirector-breadcrumb *ngIf="header" [pageName]="header.title"></safetydirector-breadcrumb>
  <safetydirector-industry-highlights></safetydirector-industry-highlights>
  <div class="row p-t-2">
    <!-- Search Box -->
    <div class="memic-input-group memic-input-group--borderless input-group memic-search--page">
      <input [(ngModel)]="searchString" (keyup.enter)="filterResources()" name="searchString" type="text" placeholder="Search">
      <button type="button" (click)="filterResources(true)" class="memic-btn-link btn bg-transparent" style="margin-left: -30px; z-index: 100;">
        <i class="fa fa-times"  style="margin-left: -30px;"></i>
      </button>
      <span (click)="filterResources()" class="input-group-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
    </div>
    <!--// Search Box -->
  </div>
  <div class="row p-t-2">
    <div class="col-md-9">
      <div class="row">
        <div class="col-md-6">
          <safetydirector-top-resources [size]="5" [industry]="industry" [latest]="true" [searchString]="searchString"></safetydirector-top-resources>
        </div>
        <div class="col-md-6">
          <safetydirector-top-resources [size]="5" [industry]="industry" [searchString]="searchString"></safetydirector-top-resources>
        </div>
      </div>
    </div>
    <div class="col-md-3">
      <safetydirector-events></safetydirector-events>
      <safetydirector-webinars-on-demand-link></safetydirector-webinars-on-demand-link>
    </div>
  </div>
</div>
